<template>
  <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
    <div class="row">
      <div class="col-sm-6 text-left">
        <div class="form-group" v-if="brandBrief.length > 2 && $route.name !== 'storeInfo'">
          <multiselect
            v-model="brandSelect"
            :options="brandBrief"
            :searchable="true"
            :allow-empty="false"
            :close-on-select="true"
            placeholder="==品牌=="
            :show-labels="false"
            :multiple="false"
            label="label"
            track-by="value"
            :disabled = "isLoading"
            @input="queryChange($event, 'brand_id')"
          />
        </div>
        <div class="form-group" v-if="brandSelect.value !== 0 && brandSelect.value !== '0' && storeBrief.length > 2 && $route.name !== 'storeInfo'">
          <multiselect
            v-model="storeSelect"
            :options="storeBrief"
            :searchable="true"
            :allow-empty="false"
            :close-on-select="true"
            placeholder="==品牌=="
            :show-labels="false"
            :multiple="false"
            label="label"
            track-by="value"
            :disabled = "isLoading"
            @input="queryChange($event, 'store_id')"
          />
        </div>
        <br>
        <div class="form-group">
          <!-- 線下訂單列表 取餐類型無桌邊掃碼 -->
          <select :disabled="isLoading" class="form-control h-38" v-model="deTypeSelect" @input="queryChange($event, 'delivery_type')">
            <option
              v-for="item in deliveryTypeList"
              :key="item.value"
              :value="item.value"
              v-show="(item.value !== 21) || (item.value === 21 && $route.name !== 'onSiteOrderTable')"
              v-text="item.label"
            />
          </select>
        </div>
        <div class="form-group text-left">
          <select :disabled = "isLoading" class="form-control h-38" v-model="statusSelect" @input="queryChange($event, 'status')">
            <option v-for="status in statusList" :value="status.value" v-text="status.label" />
          </select>
        </div>
        <div class="form-group">
          <select :disabled = "isLoading" class="form-control h-38" v-model="trTypeSelect" @input="queryChange($event, 'trade_type')">
            <option v-for="trade in getTradeType" :value="trade.value" v-text="trade.label" />
          </select>
        </div>
        <br>
      </div>
      <div class="col-sm-6 text-right">
        <div class="form-group">
          <select :disabled = "isLoading" class="form-control h-38" v-model="searchSelect" @input="queryChange($event, 'search_select')">
            <option value="1">時間</option>
            <option value="2">訂單編號</option>
            <option value="3">訂購者</option>
            <option v-if="!isGuestTab" value="4">最低跟團人數</option>
          </select>
        </div>
        <div class="form-group input-group time-box" v-if="searchSelect == 1">
          <date-time-picker v-if="!isLoading" :date="menuTime.start" :enabled="isLoading" :option="dateoption" :limit="startLimit" @change="queryChange($event, 'start_time')"/>
          <input type="text" v-else disabled v-model="menuTime.start.time" class="form-control" placeholder="起始時間" >
          <date-time-picker v-if="!isLoading" :date="menuTime.end" :option="dateoption" :limit="endLimit" @change="queryChange($event, 'end_time')"/>
          <input type="text" v-else disabled v-model="menuTime.end.time" class="form-control" placeholder="結束時間" >
          <span class="input-group-btn">
            <button :disabled="isLoading" class="btn btn-default submit-btn btn-search" type="button" id="search" style="height: 72px" @click="search(1)">
              <i class="fa fa-search" />
            </button>
          </span>
        </div>
        <div class="form-group search-bar" v-if="searchSelect == 2">
          <div class="input-group">
            <input :disabled = "isLoading" class="form-control" type="text" v-model="orderSn" @input="queryChange($event, 'order_sn')">
            <span class="input-group-addon c-pointer" @click="search(2)"><i class="fa fa-search" /></span>
          </div>
        </div>
        <div class="form-group search-bar" v-if="searchSelect == 3">
          <div class="input-group">
            <input :disabled = "isLoading" class="form-control" type="text" v-model="shopper" @input="queryChange($event, 'shopper_name')">
            <span class="input-group-addon c-pointer" @click="search(3)"><i class="fa fa-search" /></span>
          </div>
        </div>
        <div class="form-group search-bar" v-if="searchSelect == 4">
          <div class="input-group">
            <input :disabled = "isLoading" class="form-control" type="text" v-model="subOrderAmount" @input="queryChange($event, 'sub_order_amount')">
            <span class="input-group-addon c-pointer" @click="search(4)"><i class="fa fa-search" /></span>
          </div>
        </div>
      </div>
    </div>
    <!-- 線上訂單管理 tab -->
    <div v-if="isOnline" style="height: 35px">
      <div class="tab">
        <ul class="nav nav-tabs" style="margin-bottom: 10px;">
          <li role="presentation" :class="{active: typeSelect === 99}">
            <a v-if= "!isLoading" @click.prevent="typeSelect = 99">全部
            </a>
            <a class="filter-load" v-else>全部</a>
          </li>
          <li :disabled = "isLoading" role="presentation" :class="{active : typeSelect === 1}">
            <a v-if= "!isLoading" @click.prevent="typeSelect = 1">一般單
            </a>
            <a class="filter-load" v-else>一般單</a>
          </li>
          <li :disabled = "isLoading" role="presentation" :class="{active: typeSelect === 2}">
            <a v-if= "!isLoading" @click.prevent="typeSelect = 2">團購單
            </a>
            <a class="filter-load" v-else>團購單</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- 線下訂單管理 tab -->
    <div v-else style="height: 35px">
      <div class="tab">
        <ul class="nav nav-tabs" style="margin-bottom: 10px;">
          <li :disabled = "isLoading" role="presentation" :class="{active: $route.name === 'onSiteOrderMemberTable'}">
            <router-link replace :to="{path:'/onSiteOrderTable/member', query:$route.query}">會員單</router-link>
          </li>
          <li :disabled = "isLoading" role="presentation" :class="{active: $route.name === 'onSiteOrderGuestTable'}">
            <router-link replace :to="{path:'/onSiteOrderTable/guest', query:$route.query}">訪客單</router-link>
          </li>
        </ul>
      </div>
    </div>

    <div class="col-sm-12">
      <div class="download-block">
        <div>每個檔案最多{{ this.exportMaxLimit }}筆資料，超過上限會分成數個檔案下載。<span class="text-bold">（ 目前資料筆數：{{this.total}} ）</span></div>
        <div class="ml-auto">
          <button
            :disabled="isDownloading || isLoading"
            class="btn btn-default btn-table-title z-100"
            @click="exportFile">
            <i class="fa fa-download"></i>下載報表
            <Clip class="cliploading" :loading="isDownloading" :color="'#528BB8'" :size="'16px'"/>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 table-responsive p-x-0 p-b-20">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""> <span v-if="isGuestTab">POS機</span>訂單編號</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">狀態</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂單類型</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="roleType === 99">品牌(ID)</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="roleType === 99 || roleType === 30">分店(ID)</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂購人<span v-if="isGuestTab">姓名</span><span v-else-if="roleType === 99">(ID)</span></th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">總數</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">實付金額</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">付款狀態</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">{{isGuestTab?'訂單建立時間':'下訂時間'}}</th>
            <th v-if="isOnline" colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">
              追蹤碼
              <span class="nd-tooltip">
                <ion-icon name="help-circle" />
                <span class="nd-tooltip-text center">
                  「你訂團隊持續在進行系統優化，如有追蹤訂單來源需求，可自【新後台管理系統】-【成效數據中心】使用[自訂報表]下載報表分析。
                  <br>
                  此追蹤碼功能於近期將不再進行相關維護，如需更進階數據分析需求，可洽你訂同仁詢問GA4數據分析，會有專人與您詳細說明完整方案。」
                </span>
              </span>
            </th>
          </tr>
          </thead>
          <tbody v-if="isLoading">
            <tr>
              <td colspan="12" class="text-center">資料讀取中......</td>
            </tr>
          </tbody>
          <tbody v-else-if="!isLoading && orderList.length > 0">
          <tr class="even" role="row" v-for="(order, index) in orderList" :class="{'bg-pre-order': order.order_method === 2}">
            <!-- index -->
            <td class="sorting_1">{{index + 1}}</td>

            <!-- 訂單編號 -->
            <td v-if="!isGuestTab">
              <router-link :to="{path: isOffline?'/onSiteOrderTableInfo/'+order.order_id:'/orderInfo/'+order.order_id}" target="_blank">
                {{order.order_sn}}
              </router-link>&nbsp;
              <!--<span v-if="order.order_method === 2" class="label label-danger">預</span>-->
            </td>
            <td v-else>
              <router-link :to="{path: '/onSiteOrderTableInfo/'+order.shipping_case_id+'?is_guest=1'}" target="_blank">
                {{order.pos_order_sn}}
              </router-link>&nbsp;
              <!--<span v-if="order.order_method === 2" class="label label-danger">預</span>-->
            </td>

            <!-- 狀態 -->
            <td>
              <label class="label" :class="orderStateColor(order.status)">{{orderState(order.status)}}</label>
            </td>

            <!-- 訂單類型 -->
            <td>
              <div class="inline-block" style="width: 22px">
                <i v-if="order.delivery_type === 1" class="fa fa-hand-paper-o" aria-hidden="true"></i>
                <i v-if="order.delivery_type === 2" class="fa fa-inbox" aria-hidden="true"></i>
                <i v-if="order.delivery_type === 3" class="fa fa-motorcycle" aria-hidden="true" @mouseover="selectStyle(order)" @mouseout="outStyle(order)" :class="shippingStateColor(order.shipping_case_status)"></i>
                <i v-if="order.delivery_type === 4" class="fa fa-shopping-bag" aria-hidden="true"></i>
                <i v-if="order.delivery_type === 5" class="fa fa-glass" aria-hidden="true"></i>
                <i v-if="order.delivery_type === 21" class="fa fa-qrcode" aria-hidden="true"></i>
                <div class="shipping-state-label" :class="shippingStateColorBg(order.shipping_case_status)" v-show="order.active">
                  {{shippingState(order.shipping_case_status)}}
                </div>
              </div>&nbsp;
              <span v-if="order.order_type === 1" class="label label-primary">一般</span>
              <span v-if="order.order_type === 2" class="label label-warning">團購<span v-if="order.sub_order_amount">{{order.sub_order_amount}}人跟</span></span>
              <!-- 訂單來源 | 平台(1)、專屬(2)、平台LIFF(3)、專屬LIFF(4)、街口(5)、你訂APP(6) -->
              <span class="text-12 text-w-600 label-default" style="padding: 0px 3px" v-if="order.src_type === 1">P</span>
              <span class="text-12 text-w-600 label-default" style="padding: 0px 3px" v-if="order.src_type === 2">D</span>
              <span class="text-12 text-w-600 label-default" style="padding: 0px 3px" v-if="order.src_type === 3">PL</span>
              <span class="text-12 text-w-600 label-warning" style="padding: 0px 3px" v-if="order.src_type === 4">DL</span>
              <span class="text-12 text-w-600 label-default" style="padding: 0px 3px" v-if="order.src_type === 6">A</span>
              <!-- 訂單瀏覽器來源 | 網站(1)、LINE(2)、Facebook Messenger(3)、LINE LIFF(4)、街口APP(5) -->
              <span class="text-12 text-w-600 label-default" style="padding: 0px 3px" v-if="order.sub_src_type === 1">W</span>
              <span class="text-12 text-w-600 label-success" style="padding: 0px 3px" v-else-if="order.sub_src_type === 2">L</span>
              <span class="text-12 text-w-600 label-primary" style="padding: 0px 3px" v-else-if="order.sub_src_type === 3">M</span>
              <span class="text-12 text-w-600 label-success" style="padding: 0px 3px" v-else-if="order.sub_src_type === 4">LI</span>
              <span class="text-12 text-w-600 label-danger" style="padding: 0px 3px;" v-else-if="order.sub_src_type === 5">J</span>
            </td>

            <!-- 品牌(ID) -->
            <td v-if="roleType === 99">{{order.brand_name}}({{order.brand_id}})</td>

            <!-- 分店(ID) -->
            <td v-if="roleType === 99 || roleType === 30">{{order.store_name}}({{order.store_id}})</td>

            <!-- 訂購人(ID) -->
            <td>
              <span v-if="isGuestTab">
                {{ order.name }}
              </span>
              <router-link
                v-else-if="(roleType === 30 || roleType === 99) && $route.name !== 'memberOrderTable' && checkMemberShow(order.status) && isOnline"
                :to="{ path: '/memberOrderTable/' + order.shopper_id }"
                target="_blank"
              >
                {{ order.name }}
                <span v-if="roleType === 99">
                  ({{ order.shopper_id }})
                </span>
              </router-link>
              <span v-else >
                {{ order.name }}
                <span v-if="roleType === 99">
                  ({{ order.shopper_id }})
                </span>
              </span>
              <span class="tag-default text-white bg-blue" v-if="order.main_shopper_id" data-toggle="tooltip" data-placement="bottom" :title="'ID('+order.main_shopper_id+')'">主</span>
              <span class="tag-default text-white bg-orange" v-if="order.sub_shopper_id" data-toggle="tooltip" data-placement="bottom" :title="'ID('+order.sub_shopper_id+')'">副</span>
            </td>

            <!-- 總數 -->
            <td>{{order.amount}}</td>

            <!-- 實付金額 -->
            <td v-if="isOffline">
              <span :class="{'text-del': hasPaidMoneyChanged(order) }">＄{{order.money}} </span>
              <span class="text-red" v-if="hasPaidMoneyChanged(order)">＄{{order.paid_money}}</span>
            </td>
            <td v-else>
              <span :class="{'text-del': order.paid_money !== order.money + order.shipping_money}">＄{{order.money + order.shipping_money}} </span>
              <span class="text-red" v-if="order.paid_money !== order.money + order.shipping_money">＄{{order.paid_money}}</span>
            </td>

            <!-- 付款狀態 -->
            <td>
              <label class="label" :class="stateColor(order.payment_status)">
                {{ order.trade_type | tradeName }} {{ payStateName(order.payment_status) }}
              </label>
            </td>

            <!-- 訂單建立時間/下訂時間 -->
            <td>{{ isGuestTab ? getTime(order.create_time) : getTime(order.order_time) }}</td>

            <!-- 追蹤碼 -->
            <td v-if="isOnline">{{order.src_vendor_code}}</td>

          </tr>
          </tbody>
          <tbody v-else-if="!isLoading && orderList.length === 0">
            <tr style="background-color: white">
              <td rowspan="1" colspan="12" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="!orderList.length && $route.name === 'onSiteOrderTableInfo'" class="text-center m-a-100 text-light-gray">
        <span class="font-size-80"><i class="ion ion-clipboard"></i></span>
        <p class="m-t-5">沒有符合的資料</p>
      </div>
      <paginate v-show="!isLoading" :pageAmount="pageAmount" :total="total" :isActive="isActive" :groupAmount="groupAmount" :clickPage="changePage" ref="orderPaginate" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import datetimePicker from '@/components/elements/nd-date-picker.vue'
import moment from 'moment'
import $ from 'jquery'
import Clip from 'vue-spinner/src/ClipLoader.vue'
export default {
  components: {
    'date-time-picker': datetimePicker,
    'Clip': Clip
  },
  data () {
    return {
      roleType: '',
      total: 1,
      count: 20,
      orderList: [],
      shopperId: 0,
      shopper: '',
      orderSn: '',
      subOrderAmount: '',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      searchSelect: 1,
      brandSelect: {
        label: '== 品牌 ==',
        value: 0
      },
      storeSelect: {
        label: '== 門市 ==',
        value: 0
      },
      typeSelect: 99,
      statusSelect: 999,
      deTypeSelect: 999,
      trTypeSelect: 999,
      isCreatedTime: false,
      isCreatedStore: false,
      // date
      menuTime: {
        start: {
          time: moment().format('YYYY-MM-DD')
        },
        end: {
          time: moment().format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'days').format('YYYY-MM-DD')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
        }
      ],
      brandBrief: [],
      storeBrief: [],
      brandDefault: 0,
      statusList: [
        {label: '== 訂單狀態 ==', value: 999},
        {label: '訂單已送出，尚未付款', value: 1},
        {label: '付款中', value: 2},
        {label: '訂單已付款，尚未通知店家', value: 3},
        {label: '客人取消', value: 99},
        {label: '未接單', value: 100},
        {label: '已接單', value: 110},
        {label: '店家退訂', value: 120},
        {label: '系統退訂', value: 121},
        {label: '已取消', value: 122},
        {label: '已完成', value: 130},
        {label: '已作廢', value: 140}
      ],
      deliveryTypeList: [
        {label: '== 取餐類型 ==', value: 999},
        {label: '自取', value: 1},
        {label: '外送', value: 3},
        {label: '內用', value: 2},
        {label: '外帶', value: 4},
        {label: '內用-桌邊掃碼', value: 21}
      ],

      exportMaxLimit: 0,
      isLoading: false,
      isDownloading: false,
      retry: 0,
      retryTimer: null,
      retryFrequency: 0
    }
  },
  methods: {
    queryChange (event, type) { // 將搜尋條件寫入 router query，便於重整，但不更新頁面
      let query = Object.assign({}, this.$route.query)
      let value = event.target ? event.target.value : (event.value === 0 ? event.value : event.value || event)

      if (JSON.stringify(value) === '{}') return
      if (value && value !== 999) query[type] = value
      else delete query[type]
      this.$router.replace({ query })
    },
    search (method) {
      if (method === 1 && this.menuTime.start.time && this.menuTime.end.time) {
        this.getOrderList(1)
      } else if (method === 2 && this.orderSn) {
        this.getOrderList(1)
      } else if (method === 3 && this.shopper) {
        this.getOrderList(1)
      } else if (method === 4 && parseInt(this.subOrderAmount, 10)) {
        this.getOrderList(1)
      } else {
        this.$notify({
          title: '請輸入搜尋條件',
          duration: 1000,
          type: 'danger',
          width: 400
        })
      }
    },
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.changePage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.changePage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.changePage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.changePage(this.pageAmount)
        else this.changePage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    payType (type) {
      if (type === 10) {
        return '線上支付'
      } else if (type === 50) {
        return '店家支付'
      }
    },
    labelColor (type) {
      if (type === 1) {
        return 'label-default'
      } else if (type === 707 || type === 701) {
        return 'label-success'
      } else if (type === 709) {
        return 'label-danger'
      } else if (type === 710) {
        return 'label-info'
      }
    },
    stateColor (state) {
      if (state === 11) {
        return 'label-default'
      } else if (state === 12) {
        return 'label-primary'
      } else if (state === 13) {
        return 'label-success'
      } else if (state === 21) {
        return 'label-danger'
      } else if (state === 22) {
        return 'label-danger'
      }
    },
    payStateName (state) {
      if (state === 11) {
        return '未付款'
      } else if (state === 12) {
        return '付款中'
      } else if (state === 13) {
        return '已收款'
      } else if (state === 21) {
        return '退款中'
      } else if (state === 22) {
        return '已退款'
      }
    },
    orderStateColor (state) {
      switch (state) {
        case 140: // 已作廢
        case 120: // 被店家退訂
        case 121: // 被系統退訂
        case 122: // 已取消
        case 99: // 使用者取消訂單
          return 'label-danger'
        case 100: // 未接單
          return 'label-default'
        case 110: // 已接單
          return 'label-primary'
        case 130: // 已完成
          return 'label-success'
        default:
          return 'label-warning'
      }
    },
    orderState (state) {
      if (state === 0) {
        return '訂單尚未確認'
      } else if (state === 1) {
        return '訂單已送出，尚未付款'
      } else if (state === 2) {
        return '付款中'
      } else if (state === 3) {
        return '訂單已付款，尚未通知店家'
      } else if (state === 99) {
        return '客人取消'
      } else if (state === 100) {
        return '未接單'
      } else if (state === 110) {
        return '已接單'
      } else if (state === 120) {
        return '店家退訂'
      } else if (state === 121) {
        return '系統退訂'
      } else if (state === 122) {
        return '已取消'
      } else if (state === 130) {
        return '已完成'
      } else if (state === 140) {
        return '已作廢'
      }
    },
    shippingStateColor (state) {
      switch (state) {
        case 19: // 已拒絕報價
        case 59: // 自動叫件處理失敗
        case 900: // 門市取消叫件
        case 901: // 系統/門市取消
        case 910: // 第三方拒絕訂單
        case 920: // 第三方取消
        case 921: // 第三已確定叫件派司機失敗)
        case 930: // 司機取件失敗
        case 940: // 司機配送失敗
          return 'text-danger'
        case 0: // 叫件開案
          return 'text-default'
        case 10: // 已報價
        case 50: // 自動叫件處理中
        case 100: // 門市已確認叫件
        case 110: // 未分派司機
        case 120: // 第三方已分派外送員
        case 130: // 司機已取貨,開始送貨
          return 'text-primary'
        case 140: // 司機已送達
          return 'text-success'
        default:
          return ''
      }
    },
    shippingStateColorBg  (state) {
      switch (state) {
        case 19: // 已拒絕報價
        case 59: // 自動叫件處理失敗
        case 900: // 門市取消叫件
        case 901: // 系統/門市取消
        case 910: // 第三方拒絕訂單
        case 920: // 第三方取消
        case 921: // 第三已確定叫件派司機失敗)
        case 930: // 司機取件失敗
        case 940: // 司機配送失敗
          return 'bg-danger'
        case 0: // 叫件開案
          return 'bg-default'
        case 10: // 已報價
        case 50: // 自動叫件處理中
        case 100: // 門市已確認叫件
        case 110: // 未分派司機
        case 120: // 第三方已分派外送員
        case 130: // 司機已取貨,開始送貨
          return 'bg-primary'
        case 140: // 司機已送達
          return 'bg-success'
        default:
          return ''
      }
    },
    shippingState (state) {
      if (state === 0) {
        return '叫件開案'
      } else if (state === 10) {
        return '已報價'
      } else if (state === 19) {
        return '報價失敗'
      } else if (state === 50) {
        return '叫件中'
      } else if (state === 59) {
        return '叫件失敗'
      } else if (state === 100) {
        return '成立物流單'
      } else if (state === 110) {
        return '物流接單'
      } else if (state === 120) {
        return '已分派外送員'
      } else if (state === 130) {
        return '已取貨'
      } else if (state === 140) {
        return '已送達'
      } else if (state === 900 || state === 901 || state === 920 || state === 921 || state === 930 || state === 940) {
        return '門市取消叫件'
      } else if (state === 920) {
        return '媒合失敗'
      }
    },
    selectStyle (item) {
      const self = this
      self.$nextTick(() => {
        self.orderList.forEach((item) => {
          self.$set(item, 'active', false)
        })
        self.$set(item, 'active', true)
      })
    },
    outStyle (item) {
      this.$set(item, 'active', false)
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    changePage (index) {
      this.tableIndex = index
      if (index === 1) this.pageGroup = 1
      this.getOrderList()
    },
    getOrderList (page) {
      this.isLoading = true
      if (page) {
        this.tableIndex = page
        if (page === 1) this.pageGroup = 1
      }
      var self = this
      var roleType = parseInt(this.getRoleType, 10)
      var url
      const data = {
        page: this.tableIndex,
        count: this.count,
        start_time: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        order_sn: this.orderSn,
        shopper_name: this.shopper,
        sub_order_amount: this.subOrderAmount
      }

      let orderType = ''
      if (this.isOffline) {
        orderType = 'offlineOrder'
      } else {
        orderType = 'order'
      }

      if (this.isGuestTab) {
        url = '/' + orderType + '/shippingCaseList?page=' + data.page + '&size=' + data.count
      } else if (roleType === 99) {
        url = '/' + orderType + '/orderList?page=' + data.page + '&size=' + data.count
      } else if (roleType === 30) {
        url = '/' + orderType + '/brandOrderList?page=' + data.page + '&size=' + data.count
      } else if (roleType === 10) {
        url = '/' + orderType + '/storeOrderList?page=' + data.page + '&size=' + data.count
      }
      if (parseInt(this.searchSelect, 10) === 1) {
        // use time search
        url = url + '&start_time=' + data.start_time + '&end_time=' + data.end_time
      } else if (parseInt(this.searchSelect, 10) === 2 && data.order_sn) {
        // use order sn search
        url = url + '&order_sn=' + data.order_sn
      } else if (parseInt(this.searchSelect, 10) === 3 && data.shopper_name) {
        // use order sn search
        url = url + '&shopper_name=' + data.shopper_name
      } else if (parseInt(this.searchSelect, 10) === 4 && data.sub_order_amount) {
        // use sub order amount search
        url = url + '&sub_order_amount=' + data.sub_order_amount
      }
      if (this.$route.name === 'memberOrderTable' && this.shopperId) {
        // memberOrderTable:會員線上訂單列表
        url = url + '&integrate_shopper_id=' + this.shopperId
      }
      if (this.brandSelect.value !== '0' && this.brandSelect.value !== 0 && url) url = url + '&brand_id=' + this.brandSelect.value
      if (this.storeSelect.value !== '0' && this.storeSelect.value !== 0 && url) url = url + '&store_id=' + this.storeSelect.value
      if (this.typeSelect !== '99' && this.typeSelect !== 99 && url) url = url + '&order_type=' + this.typeSelect
      if (this.statusSelect !== '999' && this.statusSelect !== 999 && url) url = url + '&status=' + this.statusSelect
      if (this.deTypeSelect !== '999' && this.deTypeSelect !== 999 && url) url = url + '&delivery_type=' + this.deTypeSelect
      if (parseInt(this.trTypeSelect, 10) !== 999 && url) url = url + '&trade_type=' + this.trTypeSelect
      if (this.isGuestTab) url = url + '&is_guest_order=1'
      else if (this.isOffline) url = url + '&is_guest_order=0'

      if (url) {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.isLoading = false
            self.orderList = self.isGuestTab ? response.data.case_list : response.data.order_list
            self.total = response.data.total
            self.exportMaxLimit = response.data.export_max_limit
            if (self.orderList.length) $('.odd').css('display', 'none')
          }
        }, (error) => {
          self.isLoading = false
          self.orderList = []
          self.total = 0
          self.exportMaxLimit = 0
          self.$notify({
            title: error.response.data.message,
            text: error.response.data.description,
            duration: 3000,
            type: 'danger',
            width: 400
          })
        })
      } else {
        self.isLoading = false
      }
    },
    exportFile () {
      this.isDownloading = true

      let orderType = 'order'
      if (this.isOffline) orderType = 'offlineOrder'

      let url = orderType + '/orderListSheetsSchedule?'
      if (this.isGuestTab) url = orderType + '/caseListSheetsSchedule?'

      const data = {
        count: this.count,
        start_time: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        order_sn: this.orderSn,
        shopper_name: this.shopper,
        sub_order_amount: this.subOrderAmount
      }
      if (parseInt(this.searchSelect, 10) === 1) {
        // use time search
        url = url + 'start_time=' + data.start_time + '&end_time=' + data.end_time
      } else if (parseInt(this.searchSelect, 10) === 2 && data.order_sn) {
        // use order sn search
        url = url + '&order_sn=' + data.order_sn
      } else if (parseInt(this.searchSelect, 10) === 3 && data.shopper_name) {
        // use order sn search
        url = url + '&shopper_name=' + data.shopper_name
      } else if (parseInt(this.searchSelect, 10) === 4 && data.sub_order_amount) {
        // use sub order amount search
        url = url + '&sub_order_amount=' + data.sub_order_amount
      }

      if (this.$route.name === 'memberOrderTable' && this.shopperId) {
        // memberOrderTable:會員線上訂單列表
        url = url + '&integrate_shopper_id=' + this.shopperId
      }

      if (this.brandSelect.value !== '0' && this.brandSelect.value !== 0 && url) url = url + '&brand_id=' + this.brandSelect.value
      if (this.storeSelect.value !== '0' && this.storeSelect.value !== 0 && url) url = url + '&store_id=' + this.storeSelect.value
      if (this.typeSelect !== '99' && this.typeSelect !== 99 && url) url = url + '&order_type=' + this.typeSelect
      if (this.statusSelect !== '999' && this.statusSelect !== 999 && url) url = url + '&status=' + this.statusSelect
      if (this.deTypeSelect !== '999' && this.deTypeSelect !== 999 && url) url = url + '&delivery_type=' + this.deTypeSelect
      if (parseInt(this.trTypeSelect, 10) !== 999 && url) url = url + '&trade_type=' + this.trTypeSelect
      if (this.retry === 1) {
        url = url + '&retry=1'
      }
      if (url) {
        this.getDataH('get', url, null, (response) => {
          if (response.data.sche_info.status === 3) {
            this.isDownloading = false
            this.retry = 0
            let a = document.createElement('a')
            a.href = response.data.sche_info.file_url
            a.download = '訂單列表_' + moment().format('YYYY_MM_DD') + '.zip'
            document.body.appendChild(a)
            a.click()
            clearTimeout(this.retryTimer)
            this.retryFrequency = 0
          } else if (response.data.sche_info.status === 9) {
            this.isDownloading = false
            if (this.retryFrequency > 3) {
              alert('請聯絡客服或等24小時候再試')
              return false
            }
            var yes = confirm('輸出未完成，請聯絡客服或再試一次。')
            if (yes) {
              this.retryFrequency++
            }
            clearTimeout(this.retryTimer)
          } else {
            this.retry = 1
            this.retryTimer = setTimeout(this.exportFile, 6000)
          }
        })
      }
    },
    getBrandBrief () {
      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC'
      this.brandBrief = [{label: '== 品牌 ==', value: 0}]
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)'
            this.brandBrief.push(obj)
            if (i === 0 && (this.roleType === 10 || bList.length === 1)) {
              this.brandSelect = { label: obj.label, value: obj.value }
            }
          }

          let brandId = this.$route.query.brand_id
          if (brandId) {
            let brandSelect = this.brandBrief.find(brand => brand.value === brandId * 1)
            if (brandSelect) this.brandSelect = brandSelect
          }

          if (this.roleType === 30 || this.roleType === 99) this.getOrderList()
        }
      })
    },
    getStoreBrief (brandId) {
      return new Promise((resolve, reject) => {
        this.storeBrief = []
        this.storeBrief = [{label: '== 門市 ==', value: 0}]
        // var storeS = window.sessionStorage.getItem('Nidin_orderTable_storeS')
        var url = '/brand/' + brandId + '/storeListBrief?status=2&list_sort=name ASC'
        this.getDataH('get', url, null, (response) => {
          if (response.data.status === 200) {
            var sList = response.data.list
            // 因為沒有門市導致不繼續跑訂單列表
            if (sList.length === 0) {
              this.getOrderList()
            } else {
              for (let i = 0; i < sList.length; i++) {
                let obj = {label: sList[i].name, value: sList[i].store_id}
                this.storeBrief.push(obj)
              }
            }

            let storeId = this.$route.query.store_id
            if (!storeId) resolve()

            // 如果 router 有 storeId，可能是 "頁面重整" 或者 "換 brand" ，所以要判斷選項
            let storeSelect = this.storeBrief.find(store => store.value === storeId * 1)
            // 選項有這個門市，就直接設定
            if (storeSelect) this.storeSelect = storeSelect
            // 選項沒有這個門市，就設定清空門市
            else {
              this.queryChange(0, 'store_id')
              this.storeSelect = {label: '== 門市 ==', value: 0}
            }

            resolve()
          } else {
            reject()
          }
        })
      })
    },
    getStoreBriefOffline (brandId) {
      return new Promise((resolve, reject) => {
        const url = '/brand/' + brandId + '/storeListBrief?status=3,9&list_sort=name ASC'
        this.getDataH('get', url, null, (response) => {
          if (response.data.status === 200) {
            const sList = response.data.list
            for (let i = 0; i < sList.length; i++) {
              let obj = {
                label: `${sList[i].name}（已下架）`,
                value: sList[i].store_id
              }
              this.storeBrief.push(obj)
            }
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    checkMemberShow (status) {
      if (this.$route.name !== 'onSiteOrderTable') {
        if (this.roleType === 30) {
          if (status === 130 || status === 140) return true
          else return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    getTime (time) {
      if (!time) return ''
      return moment(time, 'YYYY-MM-DD HH:mm:ss').format('MM/DD HH:mm')
    },
    hasPaidMoneyChanged (order) {
      return order.paid_money !== null && order.paid_money !== undefined && order.paid_money !== order.money
    },
    setConfig () { // 從 router 取得 query 設定，並設定到 data
      let query = this.$route.query
      if (query.brand_id && this.brandBrief) {
        let brandSelect = this.brandBrief.find(brand => brand.value === query.brand_id * 1)
        if (brandSelect) this.brandSelect = brandSelect
      }
      if (query.store_id && this.storeBrief) {
        let storeSelect = this.storeBrief.find(store => store.value === query.store_id * 1)
        if (storeSelect) this.storeSelect = storeSelect
      }
      this.deTypeSelect = query.delivery_type * 1 || 999
      this.statusSelect = query.status * 1 || 999
      this.trTypeSelect = query.trade_type * 1 || 999
      this.searchSelect = query.search_select * 1 || 1
      this.typeSelect = query.order_type * 1 || 99
      this.menuTime.start.time = moment(query.start_time || new Date()).format('YYYY-MM-DD')
      this.menuTime.end.time = moment(query.end_time || new Date()).format('YYYY-MM-DD')
      this.orderSn = query.order_sn || ''
      this.shopper = query.shopper_name || ''
      this.subOrderAmount = query.sub_order_amount || ''
    }
  },
  created () {
    this.getBrandBrief()
    this.roleType = parseInt(this.getRoleType, 10)
    if (this.$route.name === 'memberOrderTable') this.shopperId = this.$route.params.user_id
    if (this.$route.name === 'storeInfo') {
      this.brandSelect.value = this.$route.params.brand_id
      this.count = 10
    }
  },
  mounted () {
    this.$refs.orderPaginate.tableIndex = this.tableIndex
    this.$refs.orderPaginate.pageGroup = this.pageGroup
    if (!this.$route.query.search_select) this.queryChange(this.searchSelect, 'search_select')
    if (this.$route.query.search_select * 1 === 1) {
      if (!this.$route.query.start_time) this.queryChange(this.menuTime.start.time, 'start_time')
      if (!this.$route.query.end_time) this.queryChange(this.menuTime.end.time, 'end_time')
    }

    this.setConfig()
  },
  computed: {
    ...mapGetters(['getRoleType', 'getTradeType']),
    getDataH () {
      return this.$parent.getDataH
    },
    getFile () {
      return this.$parent.getFile
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    },
    isOnline () {
      return ['memberOrderTable', 'storeInfo', 'orderTable'].includes(this.$route.name)
    },
    isOffline () {
      return ['onSiteOrderMemberTable', 'onSiteOrderGuestTable', 'onSiteOrderTable'].includes(this.$route.name)
    },
    isGuestTab () {
      return this.$route.name === 'onSiteOrderGuestTable'
    }
  },
  watch: {
    isOffline () {
      this.queryChange(0, 'brand_id')
      this.brandSelect = {
        label: '== 品牌 ==',
        value: 0
      }
    },
    $route (to, from) {
      if (this.$route.name === 'onSiteOrderTable') {
        // 如果是線下單，直接跳轉到會員單
        this.$router.replace({ name: 'onSiteOrderMemberTable' })
        return
      }

      if (!this.$route.query.search_select) this.queryChange(this.searchSelect, 'search_select')
      if (this.$route.query.search_select * 1 === 1) {
        if (!this.$route.query.start_time) this.queryChange(this.menuTime.start.time, 'start_time')
        if (!this.$route.query.end_time) this.queryChange(this.menuTime.end.time, 'end_time')
      }

      this.setConfig()

      // 僅有頁面不同時，才重新取得資料
      if (from.name !== to.name) {
        this.orderList = []
        this.getBrandBrief()
      }
    },
    async 'brandSelect.value' () {
      if (this.$route.name === 'storeInfo') {
        this.storeSelect.value = this.$route.params.store_id
        await this.getStoreBrief(this.brandSelect.value)
        await this.getStoreBriefOffline(this.brandSelect.value)
      }

      if (this.brandSelect.value !== 0 && this.brandSelect.value !== '0') {
        await this.getStoreBrief(this.brandSelect.value)
        await this.getStoreBriefOffline(this.brandSelect.value)
      }

      this.getOrderList(1)
      // window.sessionStorage.setItem('Nidin_orderTable_brandS', this.brandSelect.value)
    },
    'storeSelect.value' () {
      this.getOrderList(1)
      // window.sessionStorage.setItem('Nidin_orderTable_storeS', this.storeSelect.value)
    },
    typeSelect () {
      this.getOrderList(1)
      // window.sessionStorage.setItem('Nidin_orderTable_typeS', this.typeSelect)
    },
    statusSelect () {
      this.getOrderList(1)
      // window.sessionStorage.setItem('Nidin_orderTable_statusS', this.statusSelect)
    },
    deTypeSelect () {
      this.getOrderList(1)
      // window.sessionStorage.setItem('Nidin_orderTable_deTypeS', this.deTypeSelect)
    },
    trTypeSelect () {
      this.getOrderList(1)
      // window.sessionStorage.setItem('Nidin_orderTable_trTypeS', this.trTypeSelect)
    },
    'menuTime.end.time' () {
      var lastDay = moment(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay
      this.startLimit = [
        {
          type: 'fromto',
          to: lastDay
        }
      ]
    },
    'menuTime.start.time' () {
      var lastDay = moment(this.menuTime.start.time).add('90', 'days')
      if (lastDay < moment()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD')
      else this.menuTime.end.time = moment().format('YYYY-MM-DD')
      this.endLimit = [
        {
          type: 'fromto',
          from: moment(this.menuTime.start.time).subtract(1, 'days').format('YYYY-MM-DD'),
          to: moment(this.menuTime.end.time).add(1, 'days').format('YYYY-MM-DD')
        }
      ]
    }
  }
}
</script>
<style lang="sass" scoped>
.p-b-20
  padding-bottom: 20px
.tag-default
  border-radius: 1px
  padding: 2px
  font-size: 10px
.filter-load
  color: #AAAAAA
.form-control[disabled]
  background: #FFFFFF !important
  pointer-event: none !important
  opacity: .6 !important
.cliploading
  top: 4px
.z-100
  z-index: 100
.download-block
  display: flex
  color: #696969
  font-size: 12px
  margin-top: 10px
  align-items: center
  margin-left: 15px
.text-bold
  font-weight: bold
.ml-auto
  margin-left: auto
.shipping-state-label
  position: absolute
  width: max-content
  padding: 5px
  border-radius: 6px
  z-index: 30
  font-size: 12px
  font-weight: 600
  top: -30px
  left: -18px
.text-del
  text-decoration: line-through
.bg-pre-order
  background: #FBF4E6 !important
.active.btn-all, .active.btn-basic, .active.btn-gb
  opacity: 0.4
.p-10
 padding: 10px !important
.m-a-100
  margin-top: 140px
  margin-bottom: 100px
.font-size-80
  font-size: 80px
.time-box
  max-width: 236px
  #start-box, #end-box
    width: auto
  #start-box input
    border-radius: 3px 0px 0px 0px !important
  #end-box input
    border-radius: 0px 0px 0px 3px !important
@media screen and (max-width: 768px)
  .time-box
    max-width: calc( 100vw - 20px)
@media screen and (max-width: 768px)
 .time-box .cov-vue-date .cov-datepicker
    width: calc(100vw - 90px)
</style>



// WEBPACK FOOTER //
// OrderTableTemp.vue?6be86aaf